import React, { useCallback } from 'react';
import { useRouter } from 'next/router';
import { Typography, Box, IconButton } from '@mui/material';
import { getWindow, trackEvent } from '@surfline/web-common';
import { DisclosureIcon } from '@wavetrak/theme';
import styles from './ForecastGraphsCTADaySelector.module.scss';
import { CLICKED_SUBSCRIBE_CTA } from '../../common/constants';

const ForecastGraphsCTADaySelector: React.FC<{
  segmentProperties?: Record<string, any>;
}> = ({ segmentProperties }) => {
  const { query } = useRouter();
  const isNative = query?.native?.toString() === 'true';
  const upgradeUrl = isNative ? 'surfline://upgrade' : '/upgrade';
  const handleClick = useCallback(() => {
    trackEvent(CLICKED_SUBSCRIBE_CTA, segmentProperties ?? {});
    getWindow()?.location.assign(upgradeUrl);
  }, [segmentProperties, upgradeUrl]);

  return (
    <Box className={styles.ctaParent}>
      <Box className={styles.ctaWrapper} data-testid="day-selector-paywall">
        <Box className={styles.ctaText}>
          <Typography variant="h6" component="p" className={styles.ctaTitle}>
            Get 16-days of forecasts
          </Typography>
        </Box>
        <IconButton
          aria-label="premium upgrade link"
          className={styles.ctaAction}
          onClick={handleClick}
          disableFocusRipple
          disableRipple
          disableTouchRipple
        >
          <DisclosureIcon rotation={90} size={11} />
        </IconButton>
      </Box>
    </Box>
  );
};

export default ForecastGraphsCTADaySelector;
